import React, { useState } from "react";
// import { useTranslation } from "react-i18next";

import CardFluidHeader from "components/CardFluidHeader";

import {
  handleGetCatalogCategoriesRequest,
  handleGetCatalogBrandsRequest,
} from "store/modules/Catalog/thunk.store";

import { useAppDispatch } from "store/hooks";
import { useTranslation } from "react-i18next";
import { TabsNavigation } from "ctech-react-components";
import * as Styled from "./styles";
import AddNewModal from "./components/AddNewModal";
import AddNewProductModal from "./components/AddNewProductModal";
import TableManagerProducts from "./components/TableManagerProducts";
import TableManagerProductsSimple from "./components/TableManagerProductsSimple";
import { useProducts } from "./useProducts";
import { useBrands } from "./useBrands";
import { useCategories } from "./useCategories";

const ManageProducts = () => {
  const { t } = useTranslation();
  const { headCells, rows, ActionEditProductModal } = useProducts();
  const { headCellsBrands, rowsBrands, ActionEditBrandModal } = useBrands();
  const { headCellsCategories, rowsCategories, ActionEditModal } =
    useCategories();

  const dispatch = useAppDispatch();

  const [currentTab, setCurrentTab] = useState("1");
  const [isAddNewModalVisible, setIsAddNewModalVisible] = useState(0);

  const handleChangeTab = async (_: React.SyntheticEvent, newValue: string) => {
    setCurrentTab(newValue);
  };

  const handleModalAddProduct = async () => {
    await dispatch(handleGetCatalogCategoriesRequest()).unwrap();
    await dispatch(handleGetCatalogBrandsRequest()).unwrap();
    setIsAddNewModalVisible(1);
  };

  return (
    <Styled.Container>
      <TabsNavigation
        selectedTab={currentTab}
        tabs={[
          {
            label: t("manageProducts"),
            value: "1",
          },
          {
            label: t("manageCategory"),
            value: "2",
          },
          {
            label: t("manageBrand"),
            value: "3",
          },
        ]}
        onChangeTab={handleChangeTab}
        spaceAroundTabs
        tabStyle={{
          paddingLeft: 50,
          paddingRight: 50,
        }}
      />
      <Styled.Content>
        {currentTab === "1" && (
          <Styled.ContainerContent>
            <CardFluidHeader
              title={t("manageProducts")}
              titleButton={`${t("addProduct")} +`}
              onClick={() => handleModalAddProduct()}
              modal={
                <AddNewProductModal
                  title={t("product")}
                  isOpen={isAddNewModalVisible === 1}
                  onClose={() => setIsAddNewModalVisible(0)}
                />
              }
            />
            <ActionEditProductModal />
            <TableManagerProducts headCells={headCells} rows={rows} />
          </Styled.ContainerContent>
        )}
        {currentTab === "2" && (
          <Styled.ContainerContent>
            <CardFluidHeader
              title={t("manageCategory")}
              titleButton={`${t("addCategory")} +`}
              onClick={() => setIsAddNewModalVisible(2)}
              modal={
                <AddNewModal
                  title={t("category")}
                  isOpen={isAddNewModalVisible === 2}
                  onClose={() => setIsAddNewModalVisible(0)}
                />
              }
            />
            <ActionEditModal />
            <TableManagerProductsSimple
              headCells={headCellsCategories}
              rows={rowsCategories}
            />
          </Styled.ContainerContent>
        )}
        {currentTab === "3" && (
          <Styled.ContainerContent>
            <CardFluidHeader
              title={t("manageBrand")}
              titleButton={`${t("addBrand")} +`}
              onClick={() => setIsAddNewModalVisible(3)}
              modal={
                <AddNewModal
                  title={t("brand")}
                  isOpen={isAddNewModalVisible === 3}
                  onClose={() => setIsAddNewModalVisible(0)}
                />
              }
            />
            <ActionEditBrandModal />
            <TableManagerProductsSimple
              headCells={headCellsBrands}
              rows={rowsBrands}
            />
          </Styled.ContainerContent>
        )}
      </Styled.Content>
    </Styled.Container>
  );
};

export default ManageProducts;
